import { takeEvery, put, fork, call, all, select} from "redux-saga/effects";
import * as authSlice from "./authSlice";
import { loginApi, logoutApi, getLogosApi, getDeptLogoApi } from "./authApi";


function* onLoginStartAsync({ payload }) {
  try {
    yield put( authSlice.actions.startCall({ callType: authSlice.callTypes.action }));

    let reqBody = {
      username: payload.username,
      password: payload.password
    };

    const response = yield call(loginApi, reqBody);

    if (response.status === 200) {

      yield put(authSlice.actions.loginSuccess(response.data));

    } else {
      let error = "There was an error trying to authenticate.";

      yield put(authSlice.actions.catchError({ error, callType: authSlice.callTypes.action }));

    }
  } catch (error) {
    console.log(error);
    yield put(authSlice.actions.catchError({ error, callType: authSlice.callTypes.action }));
  }
}


function* onLogoutStartAsync() {
  try {
    const getUak = (state) => state.auth;
    const auth = yield select(getUak);
    
    if(auth.isUserAuthenticated){
      yield put( authSlice.actions.startCall({ callType: authSlice.callTypes.action }));

      let reqBody = {
        username: auth.userName,
        key: auth.sessionKey
      };

      const response = yield call(logoutApi, reqBody);
      
      if (response.status === 200) {
        yield put(authSlice.actions.loggedOut());

      } else {
        let error = "There was an error trying to logout.";
  
        yield put(authSlice.actions.catchError({error, callType: authSlice.callTypes.action}));
      }
    }     
  } catch (error) {
    console.log(error);
    yield put(
      authSlice.actions.catchError({error,
      callType: authSlice.callTypes.action,
      })
    );
  }
}

export function* OnLoadLogoAsync({ payload }){

  try{
      
      yield put(authSlice.actions.startCall({ callType: authSlice.callTypes.action }));

      const getAuth = (state) => state.auth;
      const auth = yield select(getAuth);

      if(!auth.userName || !auth.sessionKey){

          //yeild to logout generator functions
          yield * onLogoutStartAsync();
          
      }

      let reqBody = {
          username: auth.userName,
          key: auth.sessionKey
      };
      
      const response = yield call(getDeptLogoApi, payload.provAgencyId, reqBody);    

      if(response.status === 200){
          let logo = response.data;
          yield put(authSlice.actions.logoLoaded({logo}));
      }
  }
  catch(error){

      console.log(error);

  }
};

export function* OnLoadLogosAsync(){

  try{
      
      yield put(authSlice.actions.startCall({ callType: authSlice.callTypes.list }));


      //const response = yield call(getLogosApi, payload.deptId, reqBody);    
      const response = yield call(getLogosApi);     

      if(response.status === 200){
          let logosCount = response.data.length;
          let logos = response.data;
          yield put(authSlice.actions.logosLoaded({logosCount, logos}));
      }
  }
  catch(error){

      console.log(error);

  }

};




const actionTypes = {
  Login: "[Login] Login API Action",
  Logout: "[Logout] Logout API Action",
  LoadLogo:"[LoadLogo] LoadLogo API Action",
  LoadLogos:"[LoadLogos] LoadLogos API Action",
  // UserLoaded: "[Load User] User Loaded API",
};

export const actions = {
  login: (username,password) => ({ type: actionTypes.Login, payload: { username,password }}),
  logout: () => ({ type: actionTypes.Logout, payload: {undefined }}),
  loadLogos: () => ({ type: actionTypes.LoadLogos, payload: {undefined }}),
  loadLogo: (provAgencyId) => ({ type: actionTypes.LoadLogo, payload: { provAgencyId }}),


  // fulFillUser: (user) => ({ type: actionTypes.UserLoaded, payload: {user}}),
};

function* login() {
  yield takeEvery(actionTypes.Login,onLoginStartAsync);
};

function* logout() {
  yield takeEvery(actionTypes.Logout,onLogoutStartAsync);
};

function* loadLogos() {
  yield takeEvery(actionTypes.LoadLogos,OnLoadLogosAsync);
};

function* loadLogo() {
  yield takeEvery(actionTypes.LoadLogo,OnLoadLogoAsync);
};


const fSagas = [
  fork(login),
  fork(logout),
  fork(loadLogos),
  fork(loadLogo)
  // fork(fulFillUser)
];

export function* saga() {
  yield all([...fSagas]);
};
